
import { TimingFormat } from "./timing-format";
import { IGenericAccessor } from "../interfaces/i-generic-accessor";

export class ML2HtmlUtils {


    public static fixURLs(text) { // Detects http, https and ftp links without the appropriate markup
        //                     tag     inner             
        return text.replace(/<([^>]+)>([^<]+)/gm, // Match all text between tags
            function ($0, tag, inner) {
                if (
                    (tag.substr(0, 1).toLowerCase() == "a") &&
                    (tag.toLowerCase().match(/class="external-link"/)) &&
                    (tag.toLowerCase().match(/target="_blank"/))
                ) { // If we have an <a> tag with class="external-link" and target="_blank" attached the URL is already processed
                    return $0;
                } else {
                    inner = inner.replace( // Match URLs and replace them                                              
                        /^((http|https|ftp)\:\/\/)[a-z0-9\-]+\.[a-z]{2,4}(:[a-z0-9]*)?\/?([a-z0-9\-\._\?\,\'\/\\\+&amp;%\$#\=~])*/gim,
                        function ($0, protocol) {
                            let _path = "";
                            if (!protocol) {
                                _path = "http://" + $0;
                            } else {
                                _path = $0;
                            }
                            return "<a href=\"" + _path + "\" style=\"text-decoration:underline;background-color:#FFFFFF;color:#5F9EA0;cursor:pointer\" class=\"external-link\" target=\"_blank\">" + _path + "</a>";
                        }

                    );
                    return "<" + tag + ">" + inner;
                }
            }
        );
    }

    public static fixHTMLOverBL(text) {
        text = text.replace(new RegExp("(<\/title>)( ?&nbsp;)*(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2, p3) {
            return p1 + p3;
        });
        text = text.replace(new RegExp("(<\/title>>)(<span[^>]*>[\s]*[^\n]<\/span>|[\s]*)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2, p3) {
            return p1 + p3;
        });
        text = text.replace(new RegExp("(<\/title>>)(<span[^>]*>( ?&nbsp;)*<\/span>|[\s]*)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2, p3, p4) {
            return p1 + p4;
        });
        text = text.replace(new RegExp("(<\/title>)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2) {
            return p1 + "<wbr contenteditable=\"false\"><span>&nbsp;</span>" + p2;
        });
        text = text.replace(new RegExp("(.*)(<title>[^]*<\/title>)(.*)", "gi"), function (match, p1, p2, p3) {
            return p2 + p1 + p3;
        });
        return text;
    }

    // converts ML2 format from current record and returns html for display
    // the main work here is for the textcommands
    public static convertML2ToDisplayHtml(textVal: string, rec: IGenericAccessor) {
        let text = textVal;

        if (text != "") { // get's called a lot as an empty string like for every item in the list...should speed things up a bit by not trying to process an empty string!
            text = text.replace(/~C13~~C10~/g, "<br/>").replace(/~C10~/g, "<br/>").replace(/~C9~/g, "&nbsp;").replace(/~C13~/g, "");
            text = text.replace(new RegExp("\t", "g"), "&emsp;");
            // handle &#160; conversion to &nbsp;
            text = text.replace(new RegExp("&#160;&#160;", "g"), " &nbsp;");
            text = text.replace(new RegExp("&#160;", "g"), " ");

            // fix URLs
            text = text.replace(/<span xml:lang="en-us" style="([^"]*)">([^<]*)<\/span>/g,
                function ($0, style, url) {
                    if (style.match(/text-decoration:\s*underline/) && style.match(/color:\s*#5F9EA0/)) {
                        return "<a href=\"" + url + "\" style=\"text-decoration:underline;background-color:#FFFFFF;color:#5F9EA0;cursor:pointer\" class=\"external-link\" target=\"_blank\">" + url + "</a>";
                    } else {
                        return $0;
                    }
                }
            );
            text = ML2HtmlUtils.fixURLs(text);

            text = ML2HtmlUtils._stripDefaultColorStyles(text);

            let blackLineMatches = text.match(new RegExp("<span id=\"BLACKLINE\"(.*?)/span>", "g"));
            let bodyMatches = text.match(new RegExp("<body[^>]*?>", "g"));
            let bodyCloseMatches = text.match(new RegExp("</body>", "g"));
            if (blackLineMatches && blackLineMatches.length > 0) {
                let blackLine = blackLineMatches[0];
                let body = (bodyMatches.length > 0) ? bodyMatches[0] : null;
                let bodyClose = (bodyCloseMatches.length > 0) ? bodyCloseMatches[0] : null;
                let beforeBody = body ? text.split(body)[0] : "";
                let afterBody = body ? text.split(bodyClose)[1] : "";
                let inner = body ? text.split(body)[1].split(bodyClose)[0] : text;
                let aboveBlackLine = inner.split(blackLine)[0];
                if (aboveBlackLine.match(/[\u0590-\u07BF]+/) !== null) {
                    aboveBlackLine = "<div id=\"aboveBlackLine\" style=\"direction: rtl\">" + aboveBlackLine + "</div>";
                } else {
                    aboveBlackLine = "<div id=\"aboveBlackLine\" style=\"direction: ltr\">" + aboveBlackLine + "</div>";
                }
                let belowBlackLine = inner.split(blackLine)[1];
                if (belowBlackLine.match(/[\u0590-\u07BF]+/) !== null) {
                    belowBlackLine = "<div id=\"belowBlackLine\" style=\"direction: rtl\">" + belowBlackLine + "</div>";
                } else {
                    belowBlackLine = "<div id=\"belowBlackLine\" style=\"direction: ltr\">" + belowBlackLine + "</div>";
                }
                text = "";
                if (beforeBody) text += beforeBody;
                if (body) text += body;
                text += aboveBlackLine + blackLine + belowBlackLine;
                if (bodyClose) text += bodyClose;
                if (afterBody) text += afterBody;
            }

            // ensure black line can not be edited
            text = text.replace(new RegExp("<span id=\"BLACKLINE\"(.*?)/span>", "g"), "<div id=\"BLACKLINE\" oncontrolselect=\"return false;\" contenteditable=\"false\"></div>");
            const textCommands = rec.getRawValue("TextCommands");
            if (textCommands && textCommands != null) {
                // strip out the MOS Device Specific class name which is appended to MOS
                text = text.replace(new RegExp("class=\"MOS(.+?)\"", "g"), 'class="MOS" mosclass="$1"');
                text = text.replace(new RegExp("<span (class=\"PRODUCTIONCOMMAND\"\\s.*?>.*?</)span>", "g"), function (match, p1) {
                    return "<span>&nbsp;</span><wbr /><div oncontrolselect=\"return false;\" contenteditable=\"false\" " + p1 + "div><wbr /><span>&nbsp;</span>";
                });
                if (ML2HtmlUtils.isIOSDevice()) {
                    text = text.replace(/class=\"PRODUCTIONCOMMAND\"/g, "class=\"PRODUCTIONCOMMAND iOSDevice\"");
                }
                text = text.replace(new RegExp("<span (class=\"MOS[^\"]*\"\\s[^>]*?)>([^<]*)</span>", "g"), function (match, p1, p2) {
                    return "<span>&nbsp;</span><wbr /><div oncontrolselect=\"return false;\" contenteditable=\"false\" " + p1 + ">" +
                        "<div class=\"ProductionCommand-Expand-Icon\"></div>" +
                        "<div class=\"MOSInfo\"><mosInfo /></div>" +
                        "<div class=\"MOSDetails\" style=\"display: none\"><mosDetails /></div>" +
                        p2 + "</div><wbr /><span>&nbsp;</span>";
                });

                for (let command in textCommands) {
                    let guid = command;
                    let commandText = textCommands[command].replace(new RegExp("\r\n|\n", "g"), "<br/>");
                    if (commandText.length > 2) {
                        let productionCommandRegex = new RegExp("(id=\"" + guid + "\".*?>).*?(</div>)", "");
                        let mosRegex = new RegExp("(id=\"" + guid + "\".*?>.*?)(<mosInfo />)(.*?)(<mosDetails />)(.*?</div>)", "");
                        if (commandText.substring(0, 6) == "[<mos>") {
                            let objType = commandText.match("<objType>(.*?)</objType>");
                            if (objType) {
                                if ((objType[1].toUpperCase() != "SUMMARY") && (objType[1].toUpperCase() != "STILL") && (objType[1].toUpperCase() != "VIDEO") && (objType[1].toUpperCase() != "AUDIO")) objType[1] = "SUMMARY";
                                text = text.replace("class=\"MOS\"", "class=\"MOS-" + objType[1].toUpperCase() + ((ML2HtmlUtils.isIOSDevice()) ? " iOSDevice" : "") + "\"");
                            } else {
                                objType = ["", "SUMMARY"];
                                text = text.replace("class=\"MOS\"", "class=\"MOS-" + objType[1].toUpperCase() + ((ML2HtmlUtils.isIOSDevice()) ? " iOSDevice" : "") + "\"");
                            }

                            let thumbnailUrl = null;
                            let proxyPaths = commandText.match(/<objProxyPath(.*)>.*?<\/objProxyPath>/g);
                            if (proxyPaths) {
                                for (let i = 0; i < proxyPaths.length; i++) {
                                    let url = proxyPaths[i].match("<objProxyPath(.*)>(.*?)</objProxyPath>")[2];
                                    let urlChunks = url.split(".");
                                    let extension = urlChunks[urlChunks.length - 1].toLowerCase();
                                    if (
                                        (extension == "jpg") ||
                                        (extension == "jpeg") ||
                                        (extension == "png") ||
                                        (extension == "gif") ||
                                        (extension == "bmp") ||
                                        (extension == "tiff")
                                    ) {
                                        if (url.toLowerCase().indexOf("http://") == 0) {
                                            thumbnailUrl = url;
                                        } else if (url.toLowerCase().indexOf("https://") == 0) {
                                            thumbnailUrl = url;
                                        } else {
                                            thumbnailUrl = "http://" + url;
                                        }
                                        break;
                                    }
                                }
                            }

                            let abstractText = commandText.match("<mosAbstract>(.*?)</mosAbstract>");
                            if (abstractText == null || abstractText[1] == null) {
                                let slugText = commandText.match("<objSlug>(.*?)</objSlug>");
                                if (slugText == null) slugText = commandText.match("<itemSlug>([\\s\\S]*)<\/itemSlug>");

                                let itemDur = commandText.match("<objDur>(.*?)</objDur>");
                                let timebase = commandText.match("<objTB>(.*?)</objTB>");

                                let itemDuration = "";

                                if (itemDur != null && timebase != null) {
                                    itemDuration = TimingFormat.formatTime(itemDur[1] / timebase[1]);
                                }

                                text = text.replace(mosRegex, function (match, p1, p2, p3, p4, p5) {
                                    return p1 +
                                        (((slugText != null) && (slugText.length > 1)) ? (slugText[1] + " " + itemDuration) : "") + // mosInfo
                                        p3 +
                                        "<table border=\"0\" cellspacing=\"0\" cellpadding=\"5\" style=\"border: 0px\"><tr>" +
                                        (thumbnailUrl ? "<td width=\"auto\" style=\"border: 0px; min-width: 60px;\"><img style=\"height: 60px\" src=\"" + thumbnailUrl + "\" /></td>" : "<td width=\"auto\" style=\"border: 0px;\"><div class=\"thumb-" + objType[1].toUpperCase() + "\"></div></td>") +
                                        "<td valign=\"middle\" style=\"border: 0px\"><div style=\"max-width: 100px; overflow: hidden;\">" +
                                        (((slugText != null) && (slugText.length > 1)) ? (slugText[1] + " " + itemDuration) : "") + // mosDetails
                                        "</div></td></tr></table>" +
                                        p5
                                        ;
                                });
                            } else {
                                text = text.replace(mosRegex, function (match, p1, p2, p3, p4, p5) {
                                    return p1 +
                                        abstractText[1] + // mosInfo
                                        p3 +
                                        "<table border=\"0\" cellspacing=\"0\" cellpadding=\"5\" style=\"border: 0px\"><tr>" +
                                        (thumbnailUrl ? "<td width=\"auto\" style=\"border: 0px; min-width: 60px;\"><img style=\"height: 60px\" src=\"" + thumbnailUrl + "\" /></td>" : "<td width=\"auto\" style=\"border: 0px;\"><div class=\"thumb-" + objType[1].toUpperCase() + "\"></div></td>") +
                                        "<td valign=\"middle\" style=\"border: 0px\"><div style=\"max-width: 100px; overflow: hidden;\">" +
                                        abstractText[1] + // mosDetails
                                        "</div></td></tr></table>" +
                                        p5
                                        ;
                                });
                            }
                        } else {
                            text = text.replace(productionCommandRegex, "$1" + commandText.substring(1, commandText.length - 1) + "$2");
                        }
                    }
                }
            }

            // ensure an empty row if there is no content above the black line, so a user can enter content
            text = text.replace(new RegExp("(<body>)(<span[^>]*>[\s]*[^\n]<\/span>|[\s]*)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2, p3) {
                return p1 + p3;
            });
            text = text.replace(new RegExp("(<body>)(<span[^>]*>( ?&nbsp;)*<\/span>|[\s]*)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2, p3, p4) {
                return p1 + p4;
            });
            text = text.replace(new RegExp("(<body>)(<div[^>]id=\"BLACKLINE\"[^>]*?>)", "gi"), function (match, p1, p2) {
                return p1 + "<wbr contenteditable=\"false\"><span>&nbsp;</span>" + p2;
            });
        }
        if (text == "" || text == "<br>") {
            text = "<br/>";
        }
        return (text);
    }

    public static convertDisplayHTMLToML2(text) {
        //remove the trailing span (if any)
        text = text.replace(/~C13~~C10~/g, "<br/>").replace(/~C10~/g, "<br/>").replace(/~C9~/g, "&nbsp;").replace(/~C13~/g, "");
        text = text.replace(new RegExp("</title><wbr contenteditable=\"false\">", "g"), "</title>");

        //remove the beginning/trailing span (if any)
        text = text.replace(new RegExp("<span>&nbsp;</span>", "g"), "");
        // fix URLs
        text = ML2HtmlUtils.fixURLs(text);
        text = text.replace(
            /<a[^>]*target="_blank"[^>]*>([^<]*)<\/a>/g,
            "<span xml:lang=\"en-us\" style=\"text-decoration:underline;background-color:#FFFFFF;color:#5F9EA0;\">$1</span>"
        );

        // spacing, font styles and other general fixes to markup
        text = text.replace(new RegExp("&emsp;", "g"), "&#9;");
        text = text.replace(new RegExp(" &nbsp;", "g"), "&#160;&#160;");
        text = text.replace(new RegExp("&nbsp;", "g"), "&#160;");
        text = ML2HtmlUtils._stripDefaultColorStyles(text);

        text = text.replace(new RegExp("xml: lang = \"en-us\"", "g"), "");
        text = text.replace(new RegExp("<br>", "g"), "<br/>");

        text = ML2HtmlUtils.removeDivById(text, "aboveBlackLine");
        text = ML2HtmlUtils.removeDivById(text, "belowBlackLine");

        // remove black line protection
        text = text.replace(new RegExp("<div id=\"BLACKLINE\"(.*?)/div>", "g"), "<span id=\"BLACKLINE\"></span>");

        // return MIR/PC blocks to spans and remove inner content
        text = text.replace(/<wbr \/>/g, "");
        if (ML2HtmlUtils.isIOSDevice()) {
            text = text.replace(/class=\"PRODUCTIONCOMMAND iOSDevice\"/g, "class=\"PRODUCTIONCOMMAND\"");
        }
        //text = text.replace(new RegExp("<div [^>]*class=\"PRODUCTIONCOMMAND\"[^>]*>[^>]*</div>", "g"), function (match) {
        text = text.replace(/class=\"PRODUCTIONCOMMAND[^\"]\"/g, "class=\"PRODUCTIONCOMMAND\"");
        text = text.replace(new RegExp("<div [^>]*class=\"PRODUCTIONCOMMAND\"[^>]*>.*?<\/div>", "g"), function (match) {
            let id = match.match("id=\"[^\"]*\"")[0];
            return "<span class=\"PRODUCTIONCOMMAND\" " + id + "></span>";
        });
        text = text.replace(new RegExp("<div [^>]*class=\"MOS[^\"]*\"[^>]*>.*?class=\"MOSDetails\".*?</div>.*?</div>", "g"), function (match) {
            let id = match.match("id=\"[^\"]*\"")[0];
            //let mosclass = match.match("mosclass=\"[^\"]+\"")[0];
            let mosclass = match.match("mosclass=\"[^\"]*\"")[0];
            return "<span class=\"MOS\" " + mosclass + " " + id + "></span>";
        });

        text = text.replace(new RegExp("oncontrolselect=\"return false;\" contenteditable=\"false\"", "g"), "");
        text = text.replace(new RegExp("contenteditable=\"false\" oncontrolselect=\"return false;\"", "g"), "");
        text = text.replace(new RegExp(" class=\"MOS.*?\"", "g"), "");
        text = text.replace(new RegExp("mosclass=\"", "g"), "class=\"MOS");
        text = text.replace(new RegExp("<title>.*?</title>", ""), "");

        // IE and Mozilla fix convert rgb(val, val, val) to HEX
        text = text.replace(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g,
            function ($0, $1, $2, $3) {
                return "#" + ("0" + Number($1).toString(16)).substr(-2) + ("0" + Number($2).toString(16)).substr(-2) + ("0" + Number($3).toString(16)).substr(-2);
            });

        if (text.indexOf("<html") != -1) {
            // trim off anything after closing body tag
            text = text.substring(0, text.indexOf("</body>") + 7);
            text = text.substring("</head>" + 7);
        }

        // if it is a newly created empty story to remove the inserted <br/> tag so the web services to recognise it is empty
        if (text == "<br/>") {
            text = "";
        }

        if (text.indexOf("<body") == -1) {
            text = "<body>" + text + "</body>";
        }
        return text;
        // convert production commands back to original state
    }

    private static _stripDefaultColorStyles(text) {
        text = text.replace(new RegExp("color: rgb\\(0, 0, 0\\);", "g"), "");
        text = text.replace(new RegExp("color: rgb\\(255, 255, 255\\);", "g"), "");
        text = text.replace(new RegExp("background-color:#FFFFFF;", "g"), "");
        text = text.replace(new RegExp("color:#000000;", "g"), "");
        text = text.replace(new RegExp("style=\"\"", "g"), "");
        return (text);
    }

    private static removeDivById(input, id) {
        let startTagMatch = input.match("<div[^>]*id=\"" + id + "\"[^>]*>");
        if (!startTagMatch || startTagMatch.length == 0) return input;
        let startPos = input.indexOf(startTagMatch[0]);
        let endPos = ML2HtmlUtils.findClosingDiv(input, startPos);
        return input.substring(0, startPos) + input.substring(startPos + startTagMatch[0].length, endPos) + input.substring(endPos + "</div>".length, input.length);
    }

    private static findClosingDiv(input, startPos) {
        let pos = startPos;
        let depth = 0;
        while (true) {
            if (input.substring(pos, pos + "<div".length) == "<div") {
                depth++;
                pos += "<div".length;
            } else if (input.substring(pos, pos + "</div>".length) == "</div>") {
                depth--;
                if (depth == 0) return pos;
                pos++;
            } else {
                pos++;
            }
            if (pos >= input.length) return null;
        }
    }

    private static isIOSDevice() {
        if (navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/iPad/i)) {
            return true;
        } else {
            return false;
        }
    }
}
